import React from "react";
import { CreditCardHelper, unknownLogo } from "../../utils/creditCardHelper";
import { Logo, LogoContainer } from "./styles";

interface LogoBrandProps {
    brand: string;
}

const LogoBrand: React.FC<LogoBrandProps> = ({ brand }: LogoBrandProps) => {
    const cardInfo = CreditCardHelper.getCardInfo({
        type: brand
    });
    return (
        <LogoContainer isPositionAbsolute={false} height="30" width="50">
            <Logo src={CreditCardHelper.getLogoSrc(cardInfo.brand) || unknownLogo} alt={cardInfo.brand} />
        </LogoContainer>
    )
}

export default LogoBrand;